import { FilterIdsType } from '@app/components/common/FilterSelect/FilterSelect';
import { IWaterBodyRegulationsFilterOptions } from '@app/interfaces/waterbodyRegulation';
import { tableDataInit } from '@app/pages/MasterData/WaterBodyRegulations/constants';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface WaterBodyRegulationsFiltersState {
  filterOptions: IWaterBodyRegulationsFilterOptions;
  shouldTriggerFetch: boolean;
  selectedWaterbodyIds: FilterIdsType;
  selectedFishtypeIds: FilterIdsType;
  selectedWaterbodyIdsTemp: FilterIdsType;
  selectedFishtypeIdsTemp: FilterIdsType;
}

const initialState: WaterBodyRegulationsFiltersState = {
  filterOptions: tableDataInit.filterOptions,
  shouldTriggerFetch: false,
  selectedWaterbodyIds: [],
  selectedFishtypeIds: [],
  selectedWaterbodyIdsTemp: [],
  selectedFishtypeIdsTemp: [],
};

const waterBodyRegulationsFiltersSlice = createSlice({
  name: 'waterBodyRegulationsFilters',
  initialState,
  reducers: {
    setFilterOptions(state, action: PayloadAction<IWaterBodyRegulationsFilterOptions>) {
      state.filterOptions = action.payload;
    },
    setShouldTriggerFetch(state, action: PayloadAction<boolean>) {
      state.shouldTriggerFetch = action.payload;
    },

    setSelectedWaterbodyIds(state, action: PayloadAction<FilterIdsType>) {
      state.selectedWaterbodyIds = action.payload;
    },
    setSelectedFishTypesIds(state, action: PayloadAction<FilterIdsType>) {
      state.selectedFishtypeIds = action.payload;
    },

    setSelectedWaterbodyIdsTemp(state, action: PayloadAction<FilterIdsType>) {
      state.selectedWaterbodyIdsTemp = action.payload;
    },
    setSelectedFishTypesIdsTemp(state, action: PayloadAction<FilterIdsType>) {
      state.selectedFishtypeIdsTemp = action.payload;
    },

    resetFilters(state) {
      state.selectedWaterbodyIds = initialState.selectedWaterbodyIds;
      state.selectedFishtypeIds = initialState.selectedFishtypeIds;
      state.selectedWaterbodyIdsTemp = initialState.selectedWaterbodyIdsTemp;
      state.selectedFishtypeIdsTemp = initialState.selectedFishtypeIdsTemp;
      state.shouldTriggerFetch = true;
    },
  },
});

export const fetchParamsSelector = (state: { waterBodyRegulationsFilters: WaterBodyRegulationsFiltersState }) => {
  const { selectedWaterbodyIds, selectedFishtypeIds } = state.waterBodyRegulationsFilters;

  return {
    selectedWaterbodyIds,
    selectedFishtypeIds,
  };
};

export const areFiltersAppliedSelector = (state: { waterBodyRegulationsFilters: WaterBodyRegulationsFiltersState }) => {
  const { selectedWaterbodyIds, selectedFishtypeIds } = state.waterBodyRegulationsFilters;

  return !!selectedWaterbodyIds.length || !!selectedFishtypeIds.length;
};

export const activeFiltersCountSelector = (state: {
  waterBodyRegulationsFilters: WaterBodyRegulationsFiltersState;
}) => {
  const { selectedWaterbodyIds, selectedFishtypeIds } = state.waterBodyRegulationsFilters;

  let count = 0;
  if (selectedWaterbodyIds.length > 0) count++;
  if (selectedFishtypeIds.length > 0) count++;

  return count;
};

export const {
  setSelectedWaterbodyIds,
  setSelectedFishTypesIds,
  setSelectedFishTypesIdsTemp,
  setSelectedWaterbodyIdsTemp,
  setShouldTriggerFetch,
} = waterBodyRegulationsFiltersSlice.actions;

export const waterBodyRegulationsFiltersActions = waterBodyRegulationsFiltersSlice.actions;

export const waterBodyRegulationsFilters = waterBodyRegulationsFiltersSlice.reducer;
